import { useNavigate } from "react-router-dom";
import NoData from "../../assets/img/nodata_gray.svg"
import { useEffect, useState } from "react";
import { BASE_URL, TypeValueChain } from "../../helpers/constants";
import useApiRequest from "../../helpers/api_request";
import { selectAccessToken } from "../../features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { AxiosError } from "axios";
import { showToastMessage } from "../../features/generalSlice";
import { toast } from "react-toastify";
import { formatDate } from "../../helpers/commons";
import AppSpinner from "../elements/AppSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import useValueChains from "../../hooks/useValueChains";


const ValueChainsPage = () => {
    const navigate = useNavigate()
    const accessToken = useAppSelector(selectAccessToken);
    const apiRequest = useApiRequest();
    const dispatch = useAppDispatch()
   
    const { loadingValueChains, valueChains, getValueChains } = useValueChains();
    useEffect(() => {
      getValueChains();
    }, []);

    return (
        <div>
            <div className="card">
                <div className=" card-body min-h-half-screen">
                    <div className="flex">
                        <nav className="flex justify-between " aria-label="Breadcrumb">
                            <ol className="inline-flex items-center mb-3 sm:mb-0">
                                <li>
                                    <div className="flex items-center">
                                        <h5 className=" card-title ">Value chains</h5>
                                    </div>
                                </li>
                            </ol>
                        </nav>
                        <div className="flex-grow flex justify-end">
                            <button onClick={() => navigate("/create-value-chain")} type="button" className="prim-btn-2 mb-2">New Entry</button>
                        </div>
                    </div>
                    {
                        (valueChains.length === 0 && loadingValueChains == false) &&
                        <div className=" h-fit flex-grow flex flex-col justify-center ">
                            <div className="flex justify-center">
                                <div>
                                    <img className=" w-32" src={NoData} alt="" />
                                    <p>No Records Yet!</p>
                                </div>
                            </div>
                        </div>
                    }
                    {(loadingValueChains) && <AppSpinner />}

                    {(valueChains.length > 0) &&
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead>
                                <tr>
                                    <th scope="col" >
                                        Name
                                    </th>
                                    <th scope="col" >
                                        Description
                                    </th>
                                    <th scope="col" >
                                        Sub-region
                                    </th>
                                    <th scope="col" >
                                        Created
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    valueChains.map((item, key) =>
                                        <tr key={key}>
                                            <td>{item.name}</td>
                                            <td  className=" max-w-[300px]" >{item.description}</td>
                                            <td  className=" max-w-[200px]" >{item.districts.map(city => city.name).join(", ")}</td>
                                            <td>{formatDate(item.created_at, "MMM DD, YYYY H:mm")}</td>
                                            <td>
                                                <span onClick={() => navigate("/edit-value-chain/" + item.id)} className=" cursor-pointer">
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    }

                </div>
            </div>
        </div>
    )
}

export default ValueChainsPage;